import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  const footerStyle = {
    backgroundColor: 'rgba(0, 0, 0, 0.95)',
    borderTop: '1px solid #3a3a3a',
    marginTop: 'auto'
  };

  const containerStyle = {
    maxWidth: '72rem',
    margin: '0 auto',
    padding: '3rem 1.5rem'
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '2rem'
  };

  const logoSectionStyle = {
    gridColumn: 'span 1'
  };

  const logoStyle = {
    height: '2.5rem',
    width: 'auto',
    marginBottom: '1rem'
  };

  const companyDescStyle = {
    color: '#9ca3af',
    fontSize: '0.875rem',
    lineHeight: '1.6',
    marginBottom: '1rem',
    textAlign: 'left'
  };

  const copyrightStyle = {
    color: '#6b7280',
    fontSize: '0.75rem',
    textAlign: 'left'
  };

  const sectionTitleStyle = {
    color: 'white',
    fontWeight: '600',
    marginBottom: '1rem',
    textAlign: 'left'
  };

  const linkListStyle = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem'
  };

  const listItemStyle = {
    textAlign: 'left'
  };

  const linkStyle = {
    color: '#9ca3af',
    textDecoration: 'none',
    fontSize: '0.875rem',
    transition: 'color 0.3s',
    textAlign: 'left'
  };

  const serviceListStyle = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem'
  };

  const serviceItemStyle = {
    color: '#9ca3af',
    fontSize: '0.875rem',
    textAlign: 'left'
  };

  const contactItemStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '0.75rem'
  };

  const iconStyle = {
    width: '1rem',
    height: '1rem',
    color: '#dfa926',
    marginTop: '0.125rem',
    marginRight: '0.5rem',
    flexShrink: 0
  };

  const contactTextStyle = {
    color: '#9ca3af',
    fontSize: '0.875rem',
    textAlign: 'left'
  };

  const emailLinkStyle = {
    color: '#9ca3af',
    textDecoration: 'none',
    fontSize: '0.875rem',
    transition: 'color 0.3s',
    textAlign: 'left'
  };

  return (
    <footer style={footerStyle}>
      <div style={containerStyle}>
        <div style={gridStyle}>
          {/* Company Info */}
          <div style={logoSectionStyle}>
            <img 
              src="/logo.png" 
              alt="Hestia Doors Logo"
              style={logoStyle}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentNode.innerHTML = '<div style="color: #dfa926; font-size: 1.5rem; font-weight: bold; margin-bottom: 1rem;">HESTIA DOORS</div>';
              }}
            />
            <p style={companyDescStyle}>
              Premium exterior doors crafted with decades of experience and FSC certified materials.
            </p>
            <p style={copyrightStyle}>
              © 2024 Hestia Doors OÜ. All rights reserved.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={sectionTitleStyle}>Quick Links</h4>
            <ul style={linkListStyle}>
              <li style={listItemStyle}>
                <Link 
                  to="/" 
                  style={linkStyle}
                  onMouseEnter={(e) => e.target.style.color = '#dfa926'}
                  onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
                >
                  Home
                </Link>
              </li>
              <li style={listItemStyle}>
                <Link 
                  to="/products" 
                  style={linkStyle}
                  onMouseEnter={(e) => e.target.style.color = '#dfa926'}
                  onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
                >
                  Products
                </Link>
              </li>
              <li style={listItemStyle}>
                <Link 
                  to="/about" 
                  style={linkStyle}
                  onMouseEnter={(e) => e.target.style.color = '#dfa926'}
                  onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
                >
                  About
                </Link>
              </li>
              <li style={listItemStyle}>
                <Link 
                  to="/services" 
                  style={linkStyle}
                  onMouseEnter={(e) => e.target.style.color = '#dfa926'}
                  onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
                >
                  Services
                </Link>
              </li>
              <li style={listItemStyle}>
                <Link 
                  to="/quality" 
                  style={linkStyle}
                  onMouseEnter={(e) => e.target.style.color = '#dfa926'}
                  onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
                >
                  Quality
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 style={sectionTitleStyle}>Our Services</h4>
            <ul style={serviceListStyle}>
              <li style={serviceItemStyle}>Custom Manufacturing</li>
              <li style={serviceItemStyle}>Professional Installation</li>
              <li style={serviceItemStyle}>Maintenance & Repair</li>
              <li style={serviceItemStyle}>Design Consultation</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 style={sectionTitleStyle}>Contact</h4>
            <div>
              <div style={contactItemStyle}>
                <MapPin style={iconStyle} />
                <div style={contactTextStyle}>
                  <p style={{ margin: 0 }}>Päikese 1</p>
                  <p style={{ margin: 0 }}>30221 Kohtla-Järve</p>
                  <p style={{ margin: 0 }}>Estonia</p>
                </div>
              </div>
              <div style={contactItemStyle}>
                <Mail style={iconStyle} />
                <a 
                  href="mailto:info@hestiadoors.com" 
                  style={emailLinkStyle}
                  onMouseEnter={(e) => e.target.style.color = '#dfa926'}
                  onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
                >
                  info@hestiadoors.com
                </a>
              </div>
              <div style={contactItemStyle}>
                <Clock style={iconStyle} />
                <div style={contactTextStyle}>
                  <p style={{ margin: 0 }}>Mon-Fri: 8AM-6PM</p>
                  <p style={{ margin: 0 }}>Sat: 9AM-4PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
